<script>
    import Icon from "./Icon.svelte";
    import { sendBulkNotifications } from "../http";

    let isDialogOpen = false;
    let isSending = false;
    let selectedMonth;
    let selectedYear;

    const months = [
        { value: 1, label: "Styczeń" },
        { value: 2, label: "Luty" },
        { value: 3, label: "Marzec" },
        { value: 4, label: "Kwiecień" },
        { value: 5, label: "Maj" },
        { value: 6, label: "Czerwiec" },
        { value: 7, label: "Lipiec" },
        { value: 8, label: "Sierpień" },
        { value: 9, label: "Wrzesień" },
        { value: 10, label: "Październik" },
        { value: 11, label: "Listopad" },
        { value: 12, label: "Grudzień" }
    ];

    const years = Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i);

    const getDefaultPeriod = () => {
        const now = new Date();
        let month = now.getMonth() + 1;
        let year = now.getFullYear();

        if (month === 1) {
            month = 12;
            year -= 1;
        } else {
            month -= 1;
        }

        return { month, year };
    };

    const openDialog = () => {
        const defaults = getDefaultPeriod();
        selectedMonth = defaults.month;
        selectedYear = defaults.year;
        isDialogOpen = true;
    };

    const closeDialog = () => {
        if (!isSending) {
            isDialogOpen = false;
        }
    };

    const notifyAll = async () => {
        isSending = true;
        const success = await sendBulkNotifications(selectedMonth, selectedYear);
        isSending = false;
        if (success) {
            isDialogOpen = false;
        }
    };

</script>

<button class="button" type="button" on:click={openDialog}>
    <Icon name="send"/> <span>Powiadom wszystkich</span>
</button>

{#if isDialogOpen}
    <div class="modal is-active">
        <div class="modal-background" on:click={closeDialog}></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Wyślij powiadomienia zbiorcze</p>
                <button class="delete" aria-label="close" on:click={closeDialog}></button>
            </header>
            <section class="modal-card-body">
                <div class="field">
                    <label class="label">Miesiąc</label>
                    <div class="control">
                        <div class="select is-fullwidth">
                            <select bind:value={selectedMonth}>
                                {#each months as month}
                                    <option value={month.value}>{month.label}</option>
                                {/each}
                            </select>
                        </div>
                    </div>
                </div>
                <div class="field">
                    <label class="label">Rok</label>
                    <div class="control">
                        <div class="select is-fullwidth">
                            <select bind:value={selectedYear}>
                                {#each years as year}
                                    <option value={year}>{year}</option>
                                {/each}
                            </select>
                        </div>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button
                    class="button is-success"
                    class:is-loading={isSending}
                    disabled={isSending}
                    on:click={notifyAll}
                >
                    Wyślij
                </button>
                <button class="button" type="button" on:click={closeDialog}>Anuluj</button>
            </footer>
        </div>
    </div>
{/if}


